import React from "react";
import { Col, Card } from "antd";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid
} from "recharts";
import InsightsCard from "./insightChart";
import TradesSection from "./tradeChart";

const DashboardCharts = ({ data }) => {
console.log(data);

  const areaData = data?.equity_curve || []
const barData = [
  {
    name: "Wins",
    value: data?.win_loss?.wins?.length || 0,
  },
  {
    name: "Loss",
    value: data?.win_loss?.losses?.length || 0,
  },
];  const lineData = data?.score || []

  return (
    <>
      {/* Lincfolio Score */}
      <Col md={12} xs={24}>
        <Card title="Lincfolio Score">
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={lineData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="week" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="score"
                stroke="#8e44ad"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      {/* Equity Curve */}
      <Col md={12} xs={24}>
        <Card title="Equity Curve">
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart data={areaData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="pnl"
                stroke="#2980b9"
                fill="#2980b9"
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      {/* Win vs Loss */}
      <Col md={12} xs={24}>
        <Card title="Win vs Loss">
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#27ae60" barSize={50} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </Col>
        <Col md={12} xs={24}>
          <ResponsiveContainer width="100%" height={250}>
          <InsightsCard/>
          </ResponsiveContainer>
      </Col>
      <Col md={24} xs={24}>
          <ResponsiveContainer width="100%" height={250}>
<TradesSection data={data} />
          </ResponsiveContainer>
      </Col>
    </>
  );
};

export default DashboardCharts;